var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"by-loader"},[_c('span',{staticClass:"loader"}),_c('strong',{staticStyle:{"position":"absolute","right":"0","left":"0","margin":"auto","text-align":"center","bottom":"38%","color":"#333"}},[_vm._v(" "+_vm._s(_vm.$t("app.t.text89")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }